import { createClient } from "@supabase/supabase-js";

// Vite env type augmentation
declare global {
    interface ImportMeta {
        env: Record<string, string>;
    }
}

// Supabase Configuration
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

// Initialize Supabase only if keys are present to prevent top-level crashes
let supabaseInstance: any = null;
try {
    if (supabaseUrl && supabaseAnonKey) {
        supabaseInstance = createClient(supabaseUrl, supabaseAnonKey);
    }
} catch (e) {
    console.error("Critical error: Failed to initialize Supabase client", e);
}

export const supabase = supabaseInstance;

if (!supabase) {
    console.warn("Supabase credentials missing or invalid. Check your VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.");
}
